var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMensage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6154 1H2.38462C1.61991 1 1 1.61827 1 2.38095V14.119C1 14.8817 1.61991 15.5 2.38462 15.5H17.6154C18.3801 15.5 19 14.8817 19 14.119V2.38095C19 1.61827 18.3801 1 17.6154 1Z",
    stroke: "#8A8E92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.72656L9.11385 9.63132C9.36264 9.83801 9.6762 9.95119 10 9.95119C10.3238 9.95119 10.6374 9.83801 10.8862 9.63132L19 2.72656",
    stroke: "#8A8E92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMensage);
export default __webpack_public_path__ + "static/media/icoMensage.9a91e360984900456ec3b5da2365006f.svg";
export { ForwardRef as ReactComponent };